import { Cohort } from 'constants/rootConstants'
import { PLANS_DECORATIONS_INTL_1 } from 'cohorts/intl_1/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_1T } from 'cohorts/intl_1t/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_2 } from 'cohorts/intl_2/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_2LW } from 'cohorts/intl_2lw/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_D60 } from 'cohorts/intl_d60/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_D70 } from 'cohorts/intl_d70/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_HLWN70 } from 'cohorts/intl_hlwn70/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_MW } from 'cohorts/intl_mw/constants/plans-decorations'
import { PLANS_DECORATIONS_INTL_3 } from 'cohorts/intl_3/constants/plans-decorations'
import type { TPlansDecorations } from 'models/plan-decoration.model'

export const PLANS_DECORATIONS_MAP: Record<string, TPlansDecorations> = {
  [Cohort.INTL_1]: PLANS_DECORATIONS_INTL_1,
  [Cohort.INTL_1T]: PLANS_DECORATIONS_INTL_1T,
  [Cohort.INTL_2]: PLANS_DECORATIONS_INTL_2,
  [Cohort.INTL_2LW]: PLANS_DECORATIONS_INTL_2LW,
  [Cohort.INTL_D60]: PLANS_DECORATIONS_INTL_D60,
  [Cohort.INTL_D70]: PLANS_DECORATIONS_INTL_D70,
  [Cohort.INTL_HLWN70]: PLANS_DECORATIONS_INTL_HLWN70,
  [Cohort.INTL_MW]: PLANS_DECORATIONS_INTL_MW,
  [Cohort.INTL_3]: PLANS_DECORATIONS_INTL_3,
}
